import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useLocalStorage } from './useLocalStorage';
import config from './config.json';

const Step30 = ({ prevStep, nextStep, step10option }) => {

  const currentStep = 30;
  const [start_work, setStartWork] = useState('');

  const [dataLocal, setDataLocal] = useLocalStorage("audit_energetique", {
    address: ""
  });
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true); // Nouvelle variable d'état

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataLocal({...dataLocal, [name]: value});
  }; 
  
  useEffect(() => {
    const storedValue = localStorage.getItem('start_work');
    if (storedValue) {
      setStartWork(storedValue);
    }
  }, []);

  const handleChange2 = (event) => {
    const { value } = event.target;
    setStartWork(value);
    localStorage.setItem('start_work', value);
    nextStep();
  };

  const storedValue2 = localStorage.getItem('project');

  useEffect(() => {

    if (storedValue2 === 'je_reflechis_a_mes_travaux' && !start_work) {
     setSubmitButtonDisabled(true);
    } 
    else if (storedValue2 !== 'je_reflechis_a_mes_travaux' && !dataLocal.address) {
     setSubmitButtonDisabled(true);
    } else {
      setSubmitButtonDisabled(false);
    }
  }, [storedValue2, start_work, dataLocal.address]);
    
  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };

    return (
        <Container>
          <ProgressBar
            now={(currentStep / 36) * 100}
            style={{ backgroundColor: "#bad7f1" }}
          >
          <ProgressBar
            now={(currentStep / 36) * 100}
            style={{ backgroundColor: "#0be288" }}
          />
          </ProgressBar>

          <Form onSubmit={handleSubmit}>

            <div>
            {step10option.adresse && (
              <div>
                <Row className="mb-3">
                  <h2>
                    {config.step30.step}
                  </h2>
                  <h3>
                    {config.step30.title1}
                  </h3>
                </Row>
                <Row className="mb-3 justify-content-center">
                  <Col lg={6} offset-lg={3}>
                    <Form.Label>{config.step30.label1}</Form.Label>
                      <Form.Control
                      type="text"
                      name="address"
                      value={dataLocal.address}
                      onChange={handleChange}
                      required
                    />
                  </Col>
                </Row>
              </div>
            )} 
            {step10option.travaux && (
              <div>
                <Row className="mb-3">
                  <h2>
                    {config.step30.step}
                  </h2>
                  <h3>
                    {config.step30.title2}
                  </h3>
                </Row>
                <Row className="mb-3 container-bloc">
                  <Col className={`m-2 icon-container ${start_work === "le_plus_tot_possible" ? 'selected' : ''}`}>
                        <Form.Check
                          type="radio"
                          label="Le plus tôt possible"
                          value="le_plus_tot_possible"
                          checked={start_work === "le_plus_tot_possible"}
                          onChange={handleChange2}
                        />
                  </Col>
                  <Col className={`m-2 icon-container ${start_work === "dans_les_6_prochains_mois" ? 'selected' : ''}`}>
                        <Form.Check
                          type="radio"
                          label="Dans les 6 prochains mois"
                          value="dans_les_6_prochains_mois"
                          checked={start_work === "dans_les_6_prochains_mois"}
                          onChange={handleChange2}
                        />
                  </Col>
                  <Col className={`m-2 icon-container ${start_work === "plus_tard_je_ne_sais_pas" ? 'selected' : ''}`}>
                        <Form.Check
                          type="radio"
                          label="Plus tard / Je ne sais pas"
                          value="plus_tard_je_ne_sais_pas"
                          checked={start_work === "plus_tard_je_ne_sais_pas"}
                          onChange={handleChange2}
                        />
                  </Col>
                </Row>
              </div>
            )}  
        </div>
        <Row className="mt-3">
          <Col className="d-flex justify-content-between">
          <Button type="button" variant="secondary" onClick={prevStep}>
            Précédent
          </Button>
          <Button type="submit" variant="primary" className="ms-3" disabled={submitButtonDisabled}>
            Suivant
          </Button>
          </Col>
        </Row>  
          </Form>
        </Container>
    );

}

export default Step30;
